const VERSION = "8.2.0";
export {
  VERSION
};
